// Generated by Melange

import * as Fx from "../fx/fx.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as StoreFx__PlayerContext from "./playerContext.jsx";

function make(param) {
  const match = StoreFx__PlayerContext.value.contents;
  let tmp;
  if (match !== undefined) {
    tmp = {
      TAG: /* Ok */ 0,
      _0: undefined
    };
  } else {
    const audioContext = new AudioContext();
    const replayGainNode = audioContext.createGain();
    const volumeNode = audioContext.createGain();
    audioContext.createMediaElementSource(StoreFx__PlayerContext.audio).connect(replayGainNode).connect(volumeNode).connect(audioContext.destination);
    tmp = Fx.Monad_syntax.let$star(Fx.ask(undefined), (function (param) {
      const state = param.store.getState();
      volumeNode.gain.value = state.player.volume;
      Stdlib__Option.iter((function (replayGainValue) {
        replayGainNode.gain.setValueAtTime(replayGainValue, audioContext.currentTime);
      }), StoreFx__PlayerContext.replayGainValue.contents);
      StoreFx__PlayerContext.value.contents = {
        audioContext: audioContext,
        replayGainNode: replayGainNode,
        volumeNode: volumeNode
      };
      return {
        TAG: /* Ok */ 0,
        _0: undefined
      };
    }));
  }
  return Fx.Monad_syntax.let$star(tmp, (function (param) {
    return {
      TAG: /* Async */ 3,
      _0: (function (param) {
        return StoreFx__PlayerContext.audio.play().then(function (param) {
          return Promise.resolve({
            TAG: /* Ok */ 0,
            _0: undefined
          });
        }).catch(function (param) {
          return Promise.resolve({
            TAG: /* Error */ 1,
            _0: undefined
          });
        });
      })
    };
  }));
}

export {
  make,
}
/* StoreFx__PlayerContext Not a pure module */
